import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=44a2a869&"
import script from "./AdminEdit.vue?vue&type=script&lang=js&"
export * from "./AdminEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports